<template>
  <div class="session-creation">
    <v-container fill-height fluid>
      <v-layout align-center justify-center>
        <v-flex sm12 md6>
          <v-stepper v-if="!loading" v-model="steps">
            <v-stepper-header>
              <v-stepper-step :complete="steps > 1" step="1" color="mdred">{{
                $t("scheduler.session.creation.step-1.name")
              }}</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="steps > 2" step="2" color="mdred">{{
                $t("scheduler.session.creation.step-2.name")
              }}</v-stepper-step>
              <!-- TODO: Future implementation -->
              <!--<v-divider></v-divider>
              <v-stepper-step :complete="steps > 3" step="3" color="mdred">{{
                $t("scheduler.session.creation.step-3.name")
              }}</v-stepper-step>-->
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <Generation @previous="back" @next="toAdjustments"></Generation>
              </v-stepper-content>

              <v-stepper-content step="2">
                <Adjustments
                  v-if="session && steps >= 2"
                  :events="session.events"
                  :processing="sending"
                  @previous="previous"
                  @next="toConfirmation"
                ></Adjustments>
              </v-stepper-content>

              <!-- TODO: Future implementation -->
              <!--<v-stepper-content step="3">
                <Confirmation
                  v-if="session && steps == 3"
                  :events="session.events"
                  @previous="previous"
                  @next="send"
                ></Confirmation>
              </v-stepper-content>-->
            </v-stepper-items>
          </v-stepper>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Generation from "./creation-steps/Generation";
import Adjustments from "./creation-steps/Adjustments";
import adaptersOut from "@/services/data-adapter/outgoing/scheduler";

export default {
  components: {
    Generation,
    Adjustments
  },

  data: () => ({
    loading: true,
    sending: false,
    steps: 1,
    session: null
  }),

  mounted: function() {
    this.$nextTick(async function() {
      this.loading = false;
    });
  },

  methods: {
    async submit() {},

    nextSlide() {
      if (this.onboarding != this.session.events.length - 1) {
        this.onboarding++;
      }
    },

    prevSlide() {
      if (this.onboarding !== 0) {
        this.onboarding--;
      }
    },

    toAdjustments(session) {
      this.session = session;
      this.steps = 2;
    },

    toConfirmation(events) {
      this.session.events = events;
      this.send();
      // TODO: Future implementation
      /*this.$set(this.session, "events", events);
      this.steps = 3;*/
    },

    async send() {
      if (!this.sending) {
        this.sending = true;
        adaptersOut.session(this.session).then(res => {
          const group = res;
          this.$http
            .post(
              "/eventsgroups",
              { group },
              { withCredentials: true, credentials: "include", mode: "cors" }
            )
            .then(request => this.submitSuccessful(request.data))
            .catch(error => this.submitFailed(error));
        });
      }
    },

    submitSuccessful(req) {
      this.$store.dispatch(
        "system/setStatus",
        {
          type: "success",
          message: this.$t("app.actions.success.creation")
        },
        { root: true }
      );
      this.sending = false;
      this.$router.push("/sessions-management/");
    },

    submitFailed(error) {
      if (process.env.NODE_ENV !== "production") {
        console.log(error.response);
      }
      this.$store.dispatch(
        "system/setStatus",
        {
          type: "error",
          message: this.$t("app.actions.failed.creation")
        },
        { root: true }
      );
      this.sending = false;
    },

    previous() {
      this.steps--;
    },

    back() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss">
.v-picker__body {
  margin: initial;
}
</style>
